import type { Picture } from 'graphql-models';
import { type Factory } from 'walden-fast/types/mocks';

const MOCK_PICTURE: Picture = {
  id: '1',
  bitmapUrl: 'https://picsum.photos/id/323/800',
  createdAt: new Date().toISOString(),
};

export const pictureFactory: Factory<Picture> = (overrides) => ({
  ...MOCK_PICTURE,
  ...overrides,
});
